export default "__VITE_ASSET__Dvu8lAWZ__"